import React, { createContext, useContext, useState, useCallback } from 'react';
import zh from './zh';
import en from './en';

const translations = { zh, en };
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('lang') || 'zh');

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    localStorage.setItem('lang', newLang);
  }, []);

  const t = useCallback((key, params = {}) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
    }
    if (typeof val === 'string') {
      return val.replace(/\{(\w+)\}/g, (match, paramKey) => (
        Object.prototype.hasOwnProperty.call(params, paramKey) ? params[paramKey] : match
      ));
    }
    return val || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
